import React, { useEffect, useState, useRef } from "react";
import Router from "next/router";
import Modal from "react-modal";
import { paymentErrorHelper, successToaster } from "../../../../../helpers/utils";
import PaymentErrorModal from "../../../../../components/Modal/PaymentErrorModal";
import { baseUrl } from "../../../../../config/config";
import Loading from "../../../../../components/Loading";
import { callPollerApi } from "./../../../../../crud/checkout.crud";

const modalStyles = {
	content: {
		top: "50%",
		left: "50%",
		right: "auto",
		bottom: "auto",
		marginRight: "-40%",
		transform: "translate(-50%, -50%)",
		minwidth: "600px",
		maxWidth: "720px",
		minheight: "600px",
		maxheight: "80vh"
	}
};

const TapPayment = ({
	eventDetails,
	orderAmount,
	currency,
	isWidget,
	KHOrderId,
	bookingIds,
	tapPaymentUrl,
	callTapPayment,
	setCallTapPayment,
	query
}) => {
	const [openErrModal, setOpenErrModal] = useState(false);
	const [modalErrType, setModalErrType] = useState("unexpected");
	const iframeRef = useRef(null);

	useEffect(() => {
		if (callTapPayment) {
			const timer = setInterval(() => {
				try {
					const iframeReference = iframeRef.current;
					const iframeUrl = iframeReference
						? iframeReference?.contentWindow?.location?.href
						: undefined;
					if (iframeUrl) {
						if (iframeUrl?.includes(`${baseUrl}/close-tap`)) {
							clearInterval(timer);
							callTapConfirmation();
						}
					}
				} catch (err) {
					//ignore error
					//console.log(err);
				}
			}, 3000);
		}
	}, [callTapPayment]);

	const callTapConfirmation = () => {
		const threshold = 8;
		let currentIteration = 0;
		const timer = setInterval(async () => {
			try {
				if (currentIteration > threshold) throw new Error("Timed Out");
				currentIteration++;
				const res = await callPollerApi(KHOrderId);
				if (res.data.status_code === 200) {
					const data = JSON.stringify(res.data.message);
					const eventDet = JSON.stringify(eventDetails);
					sessionStorage.setItem("data", data);
					sessionStorage.setItem("eventDetails", eventDet);

					//remove utm parameters
					localStorage.removeItem("utm_campaign");
					localStorage.removeItem("utm_medium");
					localStorage.removeItem("utm_source");

					//Redirect
					if (isWidget) {
						Router.push({
							pathname: `/widget/ticket-confirmation`,
							query: query
						});
					} else if (eventDetails.redirection_url !== null) {
						if (eventDetails.redirection_url_timeout == 0) {
							window.location.replace(eventDetails.redirection_url);
						} else {
							query.redirection_url = eventDetails.redirection_url;
							query.redirection_url_timeout = eventDetails.redirection_url_timeout;
							Router.push({
								pathname: `/checkout/CustomRedirects`,
								query: query
							});
						}
					} else
						Router.push({
							pathname: `/checkout/ticket-confirmation`,
							query: `eventUrl=${eventDetails.event_url}`
						});

					setOpenErrModal(false);
					setCallTapPayment(false);
					clearInterval(timer);
				}
				if (res.data.status_code === 400) {
					setModalErrType(res.data?.message?.error?.error_code || "unexpected");
					setOpenErrModal(true);
					setCallTapPayment(false);
					clearInterval(timer);
				}
			} catch (err) {
				if (err?.response?.status !== 404) {
					setOpenErrModal(true);
					setCallTapPayment(false);
					clearInterval(timer);
				}
			}
		}, 3000);
	};

	return (
		<>
			<Modal
				isOpen={callTapPayment}
				onRequestClose={() => { }}
				shouldCloseOnEsc={false}
				shouldCloseOnOverlayClick={false}
				style={modalStyles}
			>
				<iframe
					src={tapPaymentUrl}
					title="TAP Payment"
					width="600"
					height="600"
					ref={iframeRef}
					allow="payment"
				/>
			</Modal>
			<PaymentErrorModal
				isOpen={openErrModal}
				closeModal={() => setOpenErrModal(false)}
				errorType={modalErrType}
				onClickBtn={() => Router.push(`${baseUrl}/checkout/${eventDetails.event_url}`)}
			/>
		</>
	);
};

export default TapPayment;
